import { registerConditionLabels, type ItemRegister } from '../../domain/itemRegister';
import { statusLabels } from '../../domain/status';
import { csvDocument, filenamePart } from '../../lib/csv';
import { humanizeIdentifier } from '../../lib/formatting';

const HEADER = [
  'Serial',
  'Type',
  'Build',
  'Status',
  'Condition',
  'Where',
  'Site',
  'Customer',
  'Pen',
  'Installed',
];

/** YYYY-MM-DD, which spreadsheets sort and read as a date. */
function day(timestamp: string | undefined): string {
  return timestamp ? timestamp.slice(0, 10) : '';
}

/**
 * A country's item register as CSV (tidaltech/issues#9521): one row per
 * serial, in serial order. "Where" says whether the item is in transit, at
 * one of Tidal's sites (the warehouse) or at a customer's site.
 */
export function registerCsv(register: ItemRegister): string {
  const rows = register.entries.map((entry) => [
    entry.itemId,
    entry.partType ? humanizeIdentifier(entry.partType) : '',
    entry.build ?? '',
    entry.status ? statusLabels[entry.status] : '',
    registerConditionLabels[entry.condition ?? 'CONDITION_UNSPECIFIED'],
    entry.inTransit ? 'In transit' : entry.tidalSite ? 'Warehouse' : entry.siteId ? 'Site' : '',
    entry.siteName ?? entry.siteId ?? '',
    entry.customerName ?? '',
    entry.location?.trim() ?? '',
    day(entry.installationDate),
  ]);
  return csvDocument([HEADER, ...rows]);
}

/** e.g. chile-item-register-2026-10-29.csv, dated when it was read. */
export function registerCsvFilename(country: string, register: ItemRegister): string {
  const date = day(register.readAt) || new Date().toISOString().slice(0, 10);
  return `${filenamePart(country)}-item-register-${date}.csv`;
}
